/* eslint consistent-return: "off" */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import {
  MyCarsContentWrapper,
  Title,
  VehicleCardWrapper,
  HR,
} from './VehicleCard.styles';
import VehicleDetails from '../../future-packages/vehicle-details';
import VehicleAlert from '../../future-packages/vehicle-alert';
import LoanDetails from './loan-details';
import {
  POST_PURCHASE_STATE,
  MANAGEABLE_LOAN_STATE,
  PAID_OFF_LOAN_STATE,
  TEST,
} from '../../../constants';
import { fetchMyCars, fetchContactDetails } from '../../../ducks/actions';
import type { RootState } from '../../../store/configureStore';
import MyCarsTokenRefreshHookForDev from '../../../utils/MyCarsTokenRefreshHookForDev';

const VehicleCard = () => {
  const environment = process.env.NODE_ENV || TEST;
  const history = useHistory();
  const dispatch = useDispatch();
  const myCarsApiStatus = useSelector(
    (state: RootState) => state.myCars.myCarsAPIStatus
  );
  const myCars = useSelector((state: RootState) => state.myCars.cars);
  const fetchCars = () => {
    dispatch(fetchMyCars(environment));
  };

  const getContactDetails = () => {
    dispatch(fetchContactDetails(environment));
  };

  const shouldShowLoanDetailsLink = (myCarData: any): boolean =>
    myCarData.status === POST_PURCHASE_STATE &&
    (myCarData.data?.loan?.loanState === MANAGEABLE_LOAN_STATE ||
      myCarData.data?.loan?.loanState === PAID_OFF_LOAN_STATE);

  const { isComplete: isMyCarsDetailsComplete } = useSelector(
    (state: RootState) => state.myCars.myCarsAPIStatus
  );

  const isContactDetailsComplete = useSelector(
    (state: RootState) => state.myCars.isContactDetailsComplete
  );

  useEffect(() => {
    // Fetch data only if request is not complete

    if (!isMyCarsDetailsComplete) {
      fetchCars();
    }
    if (!isContactDetailsComplete) {
      getContactDetails();
    }
  }, []);

  /** Token Retrieval code - only for Development use  */
  if (process.env.NODE_DEV_REFRESH_TOKEN_ON_EXPIRY) {
    MyCarsTokenRefreshHookForDev();
  }
  /** Token Retrieval code - only for Development use - End */

  if (myCarsApiStatus.isError || !myCarsApiStatus.isComplete) {
    return (
      <div id={myCarsApiStatus.isError ? 'landing-error-msg' : ''}>
        <Spinner />
      </div>
    );
  }

  if (myCarsApiStatus.isComplete && myCars.length === 0) {
    history.push('/error-landing-page');
  }

  return (
    <MyCarsContentWrapper>
      <Title>My Cars</Title>
      {myCars.map(
        (myCar: any) =>
          myCar.status === POST_PURCHASE_STATE && (
            <VehicleCardWrapper key={myCar.vehicle.purchaseId}>
              <VehicleAlert loanDetails={myCar.data.loan} />
              <VehicleDetails myCar={myCar.vehicle} status={myCar.status} />
              {shouldShowLoanDetailsLink(myCar) && (
                <>
                  <HR />
                  <LoanDetails vehicleId={myCar.vehicle.vehicleId} />
                </>
              )}
            </VehicleCardWrapper>
          )
      )}
    </MyCarsContentWrapper>
  );
};

export default VehicleCard;
